import React from "react";
import QRCode from "react-qr-code";
import "./StepUpAuthModal.css";

const StepUpAuthModal = ({ verificationUrl, onClose, onRefresh }) => {
  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  return (
    <div className="step-up-auth-modal-overlay" onClick={onClose}>
      <div className="step-up-auth-modal" onClick={(e) => e.stopPropagation()}>
        <div className="step-up-auth-header">
          <h2>Additional Authentication Required</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="step-up-auth-content">
          <p className="step-up-auth-message">
            Your financial institution requires additional authentication to complete this transfer.
            Please scan the QR code below with your mobile device.
          </p>
          
          <div className="qr-code-container">
            <div style={{ background: 'white', padding: '16px', borderRadius: '8px' }}>
              <QRCode 
                value={verificationUrl}
                size={300}
                level="M"
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              />
            </div>
          </div>
          
          <div className="step-up-auth-footer">
            <p className="footer-text">
              Having trouble? You can also{" "}
              <a 
                href={verificationUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="verification-link"
              >
                click here
              </a>{" "}
              to authenticate in a new window.
            </p>
            
            <div className="button-group">
              <button className="secondary-button" onClick={handleRefresh}>
                Refresh QR Code
              </button>
              <button className="primary-button" onClick={onClose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepUpAuthModal;